import { onExperimentsChange, withExperimentOverrides } from '@wix/debug-panel';
import '@wix/wix-angular';
import { IRootScopeService } from 'angular';
import ngSanitize from 'angular-sanitize';
import { wixSdkModule } from '../shared/services/wixSdk/wixSdk.module';
import { getStaticsBaseUrl } from '../shared/utils/getStaticsBaseUrl';
import { getLocale } from '../shared/utils/wix/getLocale';
import { dynamicStyleModule } from './components/DynamicStyle/DynamicStyle.module';
import { widgetModule } from './components/Widget/Widget.module';
import { bitApiModule } from './services/bitApi/bitApi.module';
import { eventsServiceModule } from './services/eventsService/eventsService.module';
import { limitServiceModule } from './services/limitService/limitService.module';
import { schemaServiceModule } from './services/schemaService/schemaService.module';
import { socialServiceModule } from './services/socialService/socialService.module';
import { wixModule } from './services/wix/wix.module';
import { artistServiceModule } from '../shared/services/artistService/artistService.module';

angular
  .module('bit.widget', [
    ngSanitize,
    'wixAngular',
    'pascalprecht.translate',
    'tmh.dynamicLocale',

    wixSdkModule.name,
    widgetModule.name,
    dynamicStyleModule.name,
    bitApiModule.name,
    eventsServiceModule.name,
    limitServiceModule.name,
    schemaServiceModule.name,
    socialServiceModule.name,
    wixModule.name,
    'wmpcp.widgets.scroll-pane',
  ])
  .config(function translationConfig(
    $translateProvider,
    tmhDynamicLocaleProvider,
  ) {
    if (window.__TRANSLATIONS__) {
      $translateProvider.translations(
        window.__LOCALE__,
        window.__TRANSLATIONS__,
      );
    }

    $translateProvider.useStaticFilesLoader({
      prefix: getStaticsBaseUrl() + 'assets/locale/widget/widget_',
      suffix: '.json',
    });
    const fallbackLanguage = 'en';
    const preferredLanguage = getLocale();

    $translateProvider.preferredLanguage(preferredLanguage);
    $translateProvider.fallbackLanguage(fallbackLanguage);

    tmhDynamicLocaleProvider.localeLocationPattern(
      'https://static.parastorage.com/unpkg/angular-i18n@1.5.11/angular-locale_{{locale}}.js',
    );
    tmhDynamicLocaleProvider.defaultLocale(preferredLanguage);

    $translateProvider.useSanitizeValueStrategy('escapeParameters');
  })
  .config((experimentManagerProvider: ExperimentManagerProvider) => {
    experimentManagerProvider.setExperiments(
      withExperimentOverrides(window.__EXPERIMENTS__),
    );
  })
  .run(($rootScope: IRootScopeService, experimentManager: any) => {
    onExperimentsChange((newExperiments) => {
      experimentManager.provider.setExperiments(newExperiments);
      $rootScope.$digest();
    });
  });
